import * as e from "react";
import "react/jsx-runtime";
import { f as n } from "./index-BwqhVa-H.js";
var a = e.createContext(void 0);
function f(r) {
  const t = e.useContext(a);
  return r || t || "ltr";
}
var s = e[" useId ".trim().toString()] || (() => {
}), u = 0;
function m(r) {
  const [t, o] = e.useState(s());
  return n(() => {
    o((i) => i ?? String(u++));
  }, [r]), t ? `radix-${t}` : "";
}
export {
  f as a,
  m as u
};
